<ng-template #content><ng-content></ng-content></ng-template>

<ng-container *ngIf="!preserveFragmentAndQueryParams">
  <a
    tappable
    [routerLink]="routerLink"
    [routerAnimation]="routerAnimation"
    [state]="state || {}"
    [fragment]="fragment ? fragment.toString() : undefined"
    [queryParams]="queryParams ? queryParams : undefined"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>

<ng-container *ngIf="preserveFragmentAndQueryParams">
  <a
    tappable
    [routerLink]="routerLink"
    [routerAnimation]="routerAnimation"
    [preserveFragment]="true"
    [queryParamsHandling]="'merge'"
    [state]="state || {}"
    [queryParams]="queryParams ? queryParams : {}"
  >
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
</ng-container>
